import React, { useContext, useEffect, useState } from 'react'
import { getImages, teamImages } from '../components/Common/const'
import { VehicleContext } from '../components/Context/VehicleContext';
import VideoModal from '../components/Common/VideoModal';

const departments = ['Leadership', 'Sales', 'Service', 'Operations', 'Accounting & Titling', 'Detailing', 'Mark Customs'];


const OurTeam = () => {

    const {getTeamMembers} = useContext(VehicleContext);

    const [teamMembers, setTeamMembers] = useState([]);

    const fetchTeamMembers = async () => {
        const data = await getTeamMembers();

        console.log(data);
    
        setTeamMembers(data);
    }
      
    useEffect(() => {
        fetchTeamMembers();
    },[]);

    useEffect(() => {

    },[])

    const [location, setLocation] = useState("all");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

    const filterItem = (location) => {
        setLocation(location);
    };


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const videoLinks = {
        "Nathan Ardizzoni": "https://youtu.be/8BNfQ_wnc-o?si=NBi1vBWeP4PiU1Oe",
        "Arianna Todd": "https://youtu.be/4mSRS1x6OoY?si=bbWs3XVkghVK7XNe",
        "Daniel Johnson": "https://youtu.be/sRu7GWXK5JQ?si=A-umu7xq5nPzj1nb",
        "Wes Tindel": "https://youtu.be/87-yA2XYjrc?si=YsQ6jDOxKQZpp0KD",
        "Connor Frizzell": "https://youtu.be/UrHBb2Aurgg?si=rRE7QMja79w8vcma",
    };

    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [videoData, setVideoData] = useState("");
    const handleVideoModal = (vidData) => {
        setVideoModalOpen(true);
        setVideoData(vidData);
        document.body.classList.add('body-overflow');
    }
    const closeVideoModal = () => {
        setVideoModalOpen(false);
        setVideoData("");
        document.body.classList.remove('body-overflow');
    }
    return (
        <>
            <section className='team-wrap common-wrap'>
                <div className='container'>
                    <div className='d-flex align-items-center justify-content-between mb-5 team-header-flex'>
                        <div className='lg-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Our Team</div>
                        <ul className='tab-list d-flex align-items-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("all")}
                                    className={location === "all" ? "active" : ""}
                                >
                                    All
                                </button>
                            </li>
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("Boerne")}
                                    className={location === "Boerne" ? "active" : ""}
                                >
                                    Boerne
                                </button>
                            </li>
                            <li>
                                <button type='button'
                                    onClick={() => filterItem("Austin")}
                                    className={location === "Austin" ? "active" : ""}
                                >
                                    Austin
                                </button>
                            </li>
                        </ul>
                    </div>
                    {/* {console.log("departments", departments)} */}
                    <div>
                        <div className="accordion team-accordion" id="accordionExample">
                            {departments.map((category, idx) => {
                                let teamList = teamMembers.filter(
                                    item =>
                                        item.department === category &&
                                        (location === "all" || item.location === location)
                                );

                                // sorting for Leadership
                                if (category.toLowerCase() === "leadership") {
                                    const priority = ["Devin Heller", "Milad Deais", "Nathan Ardizzoni", "Yvonne Garcia", "Arianna Todd", "Louis Pisano"];

                                    teamList = [
                                        ...priority
                                            .map(name => teamList.find(item => item.full_name === name))
                                            .filter(Boolean),
                                        ...teamList.filter(item => !priority.includes(item.full_name))
                                    ];
                                }
                                const updatedTeamList = teamList.map(member => ({
                                    ...member,
                                    video_link: videoLinks[member.full_name] || null
                                }));
                                return teamList.length > 0 ? (<div className="accordion-item" key={idx}>
                                    <h2 className="accordion-header  wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                                        <button
                                            className={`accordion-button fw-500 text-uppercase ps-5 ${isMobile ? idx !== 0 ? 'collapsed' : '' : ''}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                            aaria-expanded={!isMobile && idx === 0 ? 'true' : 'false'}
                                            aria-controls={`collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                        >
                                            {/* {console.log("category", category)} */}
                                            {category.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                                            {["service", "detailing", "mark customs"].includes(category.toLowerCase()) &&
                                                // active !== "all" && (
                                                    <span className="fw-300 ps-2 d-inline-block">(Boerne)</span>
                                                // )
                                            }
                                            {/* {(active !== "all" && (
                                                <span className="fw-300 ps-2 d-inline-block">({active})</span>
                                            )} */}
                                        </button>
                                    </h2>
                                    {console.log("updatedTeamList", updatedTeamList)}
                                    <div
                                        id={`collapse-${category.toLowerCase().replace(/ & /g, ' and ').replace(/\s+/g, '-')}`}
                                        className={`accordion-collapse collapse ${isMobile ? idx === 0 ? 'show' : '' : 'show'}`}
                                        {...(isMobile ? { 'data-bs-parent': '#accordionExample' } : {})}
                                    >
                                        <div className="accordion-body">
                                            <div className="d-flex flex-wrap team-flex">
                                                {updatedTeamList.map((item, index) => (
                                                    <div className="team-col wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s" key={index}>
                                                        <div className="team-box w-100">
                                                            <div className="team-image">
                                                                <img
                                                                    src={item.photo_url ? item.photo_url : teamImages('./no-photo.png')}
                                                                    alt={item.full_name}
                                                                />
                                                            </div>
                                                            <div className="team-content">
                                                                <div className="xs-title font-1-1em fw-500 text-white text-uppercase mt-4 mb-0">
                                                                    {item.full_name}
                                                                </div>
                                                                <div className="xs-title fw-400 text-white opacity-0-5">
                                                                    {item.position}
                                                                </div>
                                                                <div className='d-flex align-items-center justify-content-between mt-2 px-3'>
                                                                    <div className="text-start">
                                                                        {item.phone && (
                                                                            <a href={`tel:${item.phone}`} className="text-blue d-inline-block px-1 me-1">
                                                                                <span className="call-icon me-0">
                                                                                    <img src={getImages('call.png')} alt="call" />
                                                                                </span>
                                                                            </a>
                                                                        )}
                                                                        {item.email && (
                                                                            <a href={`mailto:${item.email}`} className="text-blue d-inline-block envelope-text px-1 me-1">
                                                                                <i className="bi bi-envelope-fill"></i>
                                                                            </a>
                                                                        )}
                                                                        {item.video_link && (
                                                                            <button type='button' onClick={()=>handleVideoModal(item)} className="text-blue d-inline-block video-icon px-1">
                                                                                <img src={getImages('icon-video.png')}/>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <div className='xs-title fw-400 text-white font-15'>{item.location}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                ) : (<div key={idx}></div>);
                            })}
                        </div>
                    </div>
                    <div className='text-center mt-4 mm-logo'>
                        <img src={getImages('mm-logo-white.png')} />
                    </div>
                </div>
            </section>
            <VideoModal open={videoModalOpen} close={closeVideoModal} videoData={videoData} modalWidth={991}/>
        </>
    )
}

export default OurTeam